var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 41,
    viewBox: "0 0 105 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06445 37.324H6.2981V16.2507H1.06445V37.324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68138 2.98535C1.64843 2.98535 0.000488281 4.63362 0.000488281 6.66657C0.000488281 8.69951 1.64843 10.3475 3.68138 10.3475C5.71432 10.3475 7.36226 8.69951 7.36226 6.66657C7.36226 4.63362 5.71432 2.98535 3.68138 2.98535Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8871 15.8105C17.9558 15.8105 13.1304 20.636 13.1304 26.5673V37.3241H18.364V26.5673C18.364 23.522 20.8418 21.0442 23.8871 21.0442C26.9325 21.0442 29.4103 23.522 29.4103 26.5673V37.3241H34.6439V26.5673C34.6439 20.636 29.8185 15.8105 23.8871 15.8105Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7761 9.26855H53.5425V27.6848C53.5425 32.9999 57.8665 37.3242 63.1815 37.3242H67.3907V32.0905H63.1815C60.7525 32.0905 58.7761 30.1142 58.7761 27.6848V21.4845H65.7552V16.2509H58.7761V9.26855Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4522 32.0986C81.4942 33.1829 78.2051 31.6583 77.1208 28.7C76.0365 25.7417 77.5611 22.453 80.5194 21.3686C83.4777 20.2843 86.7667 21.8086 87.8511 24.7672C88.9354 27.7256 87.4105 31.0143 84.4522 32.0986ZM104.582 18.6344C103.882 16.7248 101.767 15.7441 99.8574 16.4444C98.8205 16.8242 98.0609 17.6233 97.692 18.5785L97.69 18.5732C97.0096 20.333 94.1949 22.856 90.1866 18.9105L90.1882 18.9154C87.2561 16.0356 82.8166 14.9208 78.7079 16.4268C73.0248 18.5101 70.0959 24.8281 72.1789 30.5112C74.2619 36.1946 80.5802 39.1235 86.2636 37.0405C90.3721 35.5345 93.0396 31.815 93.4164 27.7223L93.4184 27.7272C93.9273 22.1259 97.7057 22.2322 99.3625 23.1353L99.3605 23.1304C100.259 23.6211 101.355 23.7395 102.392 23.3597C104.302 22.6597 105.282 20.544 104.582 18.6344Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4761 37.324H46.7097V16.2507H41.4761V37.324Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.093 2.98535C42.0601 2.98535 40.4121 4.63362 40.4121 6.66657C40.4121 8.69951 42.0601 10.3475 44.093 10.3475C46.1259 10.3475 47.7739 8.69951 47.7739 6.66657C47.7739 4.63362 46.1259 2.98535 44.093 2.98535Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b4ac37f97b2853ac9950dce5c46a6784.svg";
export { ForwardRef as ReactComponent };